<template>
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img src="@/assets/images/login.jpg" class="rounded-3" alt="login"/>
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <div class="d-inline-block mb-4">
            <img
                src="/images/viavox_group_logotyp.png"
                class="rounded-3 for-light-logo"
                alt="login"
            />
            <img
                src="/images/viavox_group_logotyp.png"
                class="rounded-3 for-dark-logo"
                alt="login"
            />
          </div>
          <h3 class="fs-28 mb-2"></h3>
          <p class="fw-medium fs-16 mb-4">
          </p>
          <!--          <div class="row justify-content-center">
                      <div class="col-lg-4 col-sm-4">
                        <a
                            href="https://www.google.com/"
                            target="_blank"
                            class="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4"
                            style="border-color: #d6dae1"
                        >
                          <img src="@/assets/images/google.svg" alt="google" />
                        </a>
                      </div>
                      <div class="col-lg-4 col-sm-4">
                        <a
                            href="https://www.facebook.com/"
                            target="_blank"
                            class="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4"
                            style="border-color: #d6dae1"
                        >
                          <img src="@/assets/images/facebook2.svg" alt="facebook2" />
                        </a>
                      </div>
                      <div class="col-lg-4 col-sm-4">
                        <a
                            href="https://www.apple.com/"
                            target="_blank"
                            class="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4"
                            style="border-color: #d6dae1"
                        >
                          <img src="@/assets/images/apple.svg" alt="apple" />
                        </a>
                      </div>
                    </div>-->
          <form @submit.prevent="logout">
            <div class="form-group mb-3">
              <button
                  type="submit"
                  class="btn btn-primary fw-medium py-2 px-3 w-100"
              >
                <div
                    class="d-flex align-items-center justify-content-center py-1"
                >
                  <i class="material-symbols-outlined text-white fs-20 me-2">
                    logout
                  </i>
                  <span>Выход</span>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {useRouter, useRoute} from "vue-router";

export default defineComponent({

  name: "LogOut",
  setup() {

    const router = useRouter();
    const route = useRoute();

    const logout = () => {
      console.log("Logging out...");
      console.log("Token before removal:", localStorage.getItem("token"));

      localStorage.removeItem("token");

      console.log("Token after removal:", localStorage.getItem("token"));

      if (route.fullPath.includes('legal')) {
        window.location.href = '/legal/authentication/login';
      } else {
        window.location.href = '/authentication/login';
      }
    };

    return {logout};
  },
});
</script>
